import { render, staticRenderFns } from "./FavoriteList.vue?vue&type=template&id=7393966c&scoped=true&"
import script from "./FavoriteList.vue?vue&type=script&lang=js&"
export * from "./FavoriteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7393966c",
  null
  
)

export default component.exports